export default __webpack_public_path__ + "static/media/Screenshot (1129).255125ea.png";